export const GW_SIMULATION_FILTER = 'gwSimulationFilter';

export const FILTERS = {
  GW_SIMULATION_FILTER,
};
